import PromoFrame from "@/components/reUsables/PromoFrame";
import { tenant } from '@/interfaces/common';

interface LeftSidebarProps {
  tenant?: tenant;
}

const LeftSidebar = ({ tenant }: LeftSidebarProps) => {
  return (
    <div className="mr-3 mt-3 mb-3 h-[calc(100vh-72px)]">
      <PromoFrame tenant={tenant} />
    </div>
  );
};
export default LeftSidebar;
